import type {
  MFEAlertState,
  ReservationAlertType,
} from '@features/home/hooks/use-dashboard-alerts-state/useDashboardAlertsState.mfe.types';

import * as React from 'react';

import type { UseMFEAlertPanelStateReturn } from './useMFEAlertPanelState.types';

export function useMFEAlertPanelState(): UseMFEAlertPanelStateReturn {
  const [mfeAlertState, setMFEAlertState] = React.useState<MFEAlertState>({
    alerts: [],
    isLoading: false,
    isError: false,
  });

  const [isMFEPanelOpen, setIsMFEPanelOpen] = React.useState<boolean>(false);
  const [selectedMFEAlertType, setSelectedMFEAlertType] =
    React.useState<ReservationAlertType | null>(null);

  const openMFEPanel = React.useCallback(
    (alertType: ReservationAlertType): void => {
      setSelectedMFEAlertType(alertType);
      setIsMFEPanelOpen(true);
    },
    []
  );

  const closeMFEPanel = React.useCallback((): void => {
    setIsMFEPanelOpen(false);
    setSelectedMFEAlertType(null);
  }, []);

  return {
    mfeAlertState,
    setMFEAlertState,
    isMFEPanelOpen,
    selectedMFEAlertType,
    openMFEPanel,
    closeMFEPanel,
  };
}
